import React from 'react';
import { Link } from 'react-router-dom';

// Mobile-only fixed bottom CTA bar with blurred backdrop. Hidden on >= 768px.
const StickyMobileCTA = () => (
  <div className="vipo-sticky-mobile">
    <Link
      to="https://app.rentid.io/sign-up"
      className="vipo-btn vipo-btn--primary vipo-sticky-mobile__btn"
    >
      Get started
    </Link>
  </div>
);

export default StickyMobileCTA;
